import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { UtilitiesService } from '../../services/utilities/utilities.service';
import { ValidationRule } from 'devextreme/common';
import ValidationEngine from 'devextreme/ui/validation_engine';
import { AreaFilterTypeEnum } from '../../enum/area-filter-type.enum';
import { GeoManagementService } from '../../services/geo-management/geo-management.service';
import { AreaModel } from '../../interface/geo-location-management/geo-location-management.interface';
import { ProjectOfficeService } from '../../services/project-office/project-office.service';
import { ProjectComponent } from '../project/project.component';
import { ReportService } from 'src/app/shared/services/report/report.service';
import { StaffMappingService } from '../../services/staff-mapping/staff-mapping.service';
import { RoleHierarchyService } from '../../services/role-hierarchy/role-hierarchy.service';
import { Observable, filter, lastValueFrom, mergeMap, of, toArray } from 'rxjs';
import { IUserProjectAreaIds } from '../../interface/staff-mapping/user-project-area-ids.interface';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';

@Component({
  selector: 'app-area',
  templateUrl: './area.component.html',
  styleUrls: ['./area.component.css'],
})
export class AreaComponent implements OnInit, OnChanges {
  @Input() isEditing = false;

  @Input() isMultiProject = false;

  @Input() areaTypeLevel: string;

  @Input() filterStaff: boolean;

  @Input() validators: ValidationRule[];

  @Input() areaValidationGroupName: string;

  @Output() valueChange = new EventEmitter<any>();

  @Input() projectId: string;

  @Input() isWorkingTypeFilter: boolean = false;

  @Input() isWardShow: boolean = false;

  @Input() isFromDataCollection = false;

  @ViewChild(ProjectComponent, { static: false })
  projectComponent: ProjectComponent;

  divisionList: any[];
  districtList: any[];
  subDistrictList: any[];
  unionList: any[];
  wardList: any[];
  areaModel: AreaModel = new AreaModel();
  divisionLoader: boolean;
  districtLoader: boolean;
  subdistrictLoader: boolean;
  unionLoader: boolean;
  wardLoader: boolean;
  selectedDIVISION: any[] = [];
  selectedDISTRICT: any[] = [];
  selectedSUB_DISTRICT: any[] = [];
  selectedUNION: any[] = [];
  selectedWARD: any[] = [];

  headofficeStaffList: any[];
  divisionStaffList: any[];
  districtStaffList: any[];
  sub_districtStaffList: any[];
  upazilaStaffList: any[] = [];
  unionStaffList: any[];
  wardStaffList: any[];

  selectedHeadofficeStaff: any[] = [];
  selectedDIVISIONStaff: any[] = [];
  selectedDISTRICTStaff: any[] = [];
  selectedSUB_DISTRICTStaff: any[] = [];
  selectedUNIONStaff: any[] = [];
  selectedWARDStaff: any[] = [];
  workingAreaTypes: any;
  workingAreaTypesAndStaffs: any[] = [];
  areaFilterTypeEnum = AreaFilterTypeEnum;
  projectUserAreaIds: IUserProjectAreaIds;

  constructor(
    public reportService: ReportService,
    public geoLocationService: GeoManagementService,
    public utilitiesService: UtilitiesService,
    public staffMappingService: StaffMappingService,
    public projectOfficeService: ProjectOfficeService,
    public roleHierarchyService: RoleHierarchyService,
    private localStorageService: LocalStorageService,
  ) {}

  ngOnInit() {
    //this.getDivisionList();
  }

  ngOnChanges() {
    /**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES **************/
    if (this.projectId) {
      // this.getDivisionList(this.projectId);
      //   let firstProject = this.projectId.split(',')[0];
      //   this.getAreaTypeByProject(firstProject);
      if (this.isWorkingTypeFilter) {
        this.getDivisionList(this.projectId);
        let firstProject = this.projectId.split(',')[0];
        this.getAreaTypeByProject(firstProject);
      } else {
        if (this.isFromDataCollection) {
          this.getProjectUserAreaIds();
        } else {
          // This is for multi project
          this.getDivisionList(this.projectId);
          let firstProject = this.projectId.split(',')[0];
          this.getAreaTypeByProject(firstProject);
        }
      }
    } else {
      this.workingAreaTypes = [];
      this.divisionList = [];
      ValidationEngine.resetGroup(this.areaValidationGroupName);
    }

    this.selectedDIVISION = [];
    this.selectedDISTRICT = [];
    this.selectedSUB_DISTRICT = [];
    this.selectedUNION = [];
    this.selectedWARD = [];

    this.selectedHeadofficeStaff = [];
    this.selectedDIVISIONStaff = [];
    this.selectedDISTRICTStaff = [];
    this.selectedSUB_DISTRICTStaff = [];
    this.selectedUNIONStaff = [];
    this.selectedWARDStaff = [];
  }

  private filterNamesByIds(array: any[], ids: any[]): any[] {
    return array
      ?.filter((staff) => ids.includes(staff.user_id))
      .map((staff) => staff.name);
  }

  valueChanged(
    area: string = null,
    areaIds: { id: string; name: string }[] = null,
  ) {
    this.areaModel.allAreaData = {
      ward: this.wardList,
      union: this.unionList,
      sub_district: this.subDistrictList,
      district: this.districtList,
      division: this.divisionList,
    };
    area =
      this.areaModel.ward.length > 0
        ? AreaFilterTypeEnum.WARD
        : this.areaModel.union.length > 0
          ? AreaFilterTypeEnum.UNION
          : this.areaModel.sub_district.length > 0
            ? AreaFilterTypeEnum.SUB_DISTRICT
            : this.areaModel.district.length > 0
              ? AreaFilterTypeEnum.DISTRICT
              : AreaFilterTypeEnum.DIVISION;

    this.emitAreaModel(area);
  }

  private getDivisionList(projectId) {
    this.divisionLoader = true;
    this.divisionList = [];
    this.projectOfficeService
      .getProjectOfficeAreaListByProjects(
        projectId,
        AreaFilterTypeEnum.DIVISION,
      )
      .pipe(
        mergeMap((x) => x),
        filter((x: any) =>
          this.isFromDataCollection
            ? this.projectUserAreaIds?.division_id.some(
                (id) => id === x.division_id,
              )
            : true,
        ),
        toArray(),
      )
      .subscribe(
        (result) => {
          this.divisionLoader = false;
          this.divisionList = this.utilitiesService.getFiltered(
            result,
            'is_active',
            true,
          );

          // distinct division by division_id
          this.divisionList = this.divisionList.filter(
            (item, index, self) =>
              index ===
              self.findIndex((i) => i.division_id === item.division_id),
          );
        },
        (err) => {
          this.divisionLoader = false;
        },
      );
  }

  public divisionOptionChange(e) {
    this.resetArrayUpTo(AreaFilterTypeEnum.DIVISION);
    if (e.value.length > 0) {
      e.value.forEach((element) => {
        if (element) {
          this.areaModel.division.push({
            id: element.division_id,
            name: element.division_name,
            project_id: element.project_id,
          });

          let index = this.selectedDIVISION.findIndex(
            (s) => s == element.division_id,
          );
          if (index <= -1) {
            this.selectedDIVISION.push(element.division_id);
          }
        }
      });
      if (this.areaModel.division.length != 0) {
        let projectId = this.isMultiProject
          ? Array.from(
              new Set(this.areaModel.division.map((obj) => obj.project_id)),
            ).toString()
          : this.projectId;
        this.getDistrictList(
          projectId,
          this.areaModel.division.map((obj) => obj.id).toString(),
        );
      }
      this.valueChanged(AreaFilterTypeEnum.DIVISION, this.areaModel.division);
    } else if (e.value.length == 0 && e.previousValue.length > 0) {
      this.valueChange.emit(new AreaModel());
    }
  }

  private getDistrictList(projectId: string, divisionId: string) {
    this.districtList = [];
    this.districtLoader = true;
    this.projectOfficeService
      .getProjectOfficeAreaListByProjects(
        projectId,
        AreaFilterTypeEnum.DISTRICT,
        divisionId,
      )
      .pipe(
        mergeMap((x) => x),
        filter((x: any) =>
          this.isFromDataCollection
            ? this.projectUserAreaIds?.district_id.some(
                (id) => id === x.district_id,
              )
            : true,
        ),
        toArray(),
      )
      .subscribe(
        (result) => {
          this.districtLoader = false;
          this.districtList = this.utilitiesService.getFiltered(
            result,
            'is_active',
            true,
          );
          this.districtList = this.districtList.sort(
            this.utilitiesService.dynamicSort('district_name'),
          );

          if (this.isMultiProject) {
            // add custom_district_name like district_name(division_name)
            this.districtList.forEach((element) => {
              element.district_name = `${element.district_name} (${element.division_name})`;
            });
          }

          this.districtList = this.districtList.filter(
            (item, index, self) =>
              index ===
              self.findIndex((i) => i.district_id === item.district_id),
          );
        },
        (err) => {
          this.districtLoader = false;
        },
      );
  }

  public districtOptionChange(e) {
    this.resetArrayUpTo(AreaFilterTypeEnum.DISTRICT);
    if (e.value.length > 0) {
      e.value.forEach((element) => {
        if (element) {
          this.areaModel.district.push({
            id: element.district_id,
            name: element.district_name,
            project_id: element.project_id,
          });

          let index = this.selectedDISTRICT.findIndex(
            (s) => s == element.district_id,
          );
          if (index <= -1) {
            this.selectedDISTRICT.push(element.district_id);
          }
        }
      });
      if (this.areaModel.district.length != 0) {
        let projectId = this.isMultiProject
          ? Array.from(
              new Set(this.areaModel.district.map((obj) => obj.project_id)),
            ).toString()
          : this.projectId;
        this.getSubDistrictList(
          projectId,
          this.areaModel.district.map((obj) => obj.id).toString(),
        );
      }
      this.valueChanged(AreaFilterTypeEnum.DISTRICT, this.areaModel.district);
    } else if (e.value.length == 0 && e.previousValue.length > 0) {
      this.valueChanged(AreaFilterTypeEnum.DIVISION, this.areaModel.division);
    }
  }

  private getSubDistrictList(projectId: string, districtId: string) {
    this.subDistrictList = [];
    this.subdistrictLoader = true;
    this.projectOfficeService
      .getProjectOfficeAreaListByProjects(
        projectId,
        AreaFilterTypeEnum.SUB_DISTRICT,
        districtId,
      )
      .pipe(
        mergeMap((x) => x),
        filter((x: any) =>
          this.isFromDataCollection
            ? this.projectUserAreaIds?.sub_district_id.some(
                (id) => id === x.sub_district_id,
              )
            : true,
        ),
        toArray(),
      )
      .subscribe(
        (result) => {
          this.subdistrictLoader = false;
          this.subDistrictList = this.utilitiesService.getFiltered(
            result,
            'is_active',
            true,
          );
          this.subDistrictList = this.subDistrictList.sort(
            this.utilitiesService.dynamicSort('sub_district_name'),
          );
          if (this.isMultiProject) {
            // add custom_sub_district_name like sub_district_name(district_name)
            this.subDistrictList.forEach((element) => {
              element.sub_district_name = `${element.sub_district_name} (${element.district_name})`;
            });
          }

          this.subDistrictList = this.subDistrictList.filter(
            (item, index, self) =>
              index ===
              self.findIndex((i) => i.sub_district_id === item.sub_district_id),
          );
        },
        (err) => {
          this.subdistrictLoader = false;
        },
      );
  }

  public subDistrictOptionChange(e) {
    this.resetArrayUpTo(AreaFilterTypeEnum.SUB_DISTRICT);
    if (e.value.length > 0) {
      e.value.forEach((element) => {
        if (element) {
          this.areaModel.sub_district.push({
            id: element.sub_district_id,
            name: element.sub_district_name,
            project_id: element.project_id,
          });

          let index = this.selectedSUB_DISTRICT.findIndex(
            (s) => s == element.sub_district_id,
          );
          if (index <= -1) {
            this.selectedSUB_DISTRICT.push(element.sub_district_id);
          }
        }
      });
      if (this.areaModel.sub_district.length != 0) {
        let projectId = this.isMultiProject
          ? Array.from(
              new Set(this.areaModel.sub_district.map((obj) => obj.project_id)),
            ).toString()
          : this.projectId;
        this.getUnionList(
          projectId,
          this.areaModel.sub_district.map((obj) => obj.id).toString(),
        );
      }
      this.valueChanged(
        AreaFilterTypeEnum.SUB_DISTRICT,
        this.areaModel.sub_district,
      );
    } else if (e.value.length == 0 && e.previousValue.length > 0) {
      this.valueChanged(AreaFilterTypeEnum.DISTRICT, this.areaModel.district);
    }
  }

  private getUnionList(projectId: string, subDistrictId: string) {
    this.unionList = [];
    this.unionLoader = true;
    this.projectOfficeService
      .getProjectOfficeAreaListByProjects(
        projectId,
        AreaFilterTypeEnum.UNION,
        subDistrictId,
      )
      .pipe(
        mergeMap((x) => x),
        filter((x: any) =>
          this.isFromDataCollection
            ? this.projectUserAreaIds?.union_id.some((id) => id === x.union_id)
            : true,
        ),
        toArray(),
      )
      .subscribe(
        (result) => {
          this.unionLoader = false;

          this.unionList = this.utilitiesService.getFiltered(
            result,
            'is_active',
            true,
          );
          this.unionList = this.unionList.sort(
            this.utilitiesService.dynamicSort('union_name'),
          );
          if (this.isMultiProject) {
            // add custom_union_name like union_name(district_name)
            this.unionList.forEach((element) => {
              element.union_name = `${element.union_name} (${element.sub_district_name})`;
            });
          }
          this.unionList = this.unionList.filter(
            (item, index, self) =>
              index === self.findIndex((i) => i.union_id === item.union_id),
          );
        },
        (err) => {
          this.unionLoader = false;
        },
      );
  }

  public unionOptionChange(e) {
    this.resetArrayUpTo(AreaFilterTypeEnum.UNION);
    if (e.value.length > 0) {
      e.value.forEach((element) => {
        if (element) {
          this.areaModel.union.push({
            id: element.union_id,
            name: element.union_name,
            project_id: element.project_id,
          });

          let index = this.selectedUNION.findIndex(
            (s) => s == element.union_id,
          );
          if (index <= -1) {
            this.selectedUNION.push(element.union_id);
          }
        }
      });
      if (this.areaModel.union.length != 0) {
        let projectId = this.isMultiProject
          ? Array.from(
              new Set(this.areaModel.union.map((obj) => obj.project_id)),
            ).toString()
          : this.projectId;
        this.getWardList(
          projectId,
          this.areaModel.union.map((obj) => obj.id).toString(),
        );
      }
      this.valueChanged(AreaFilterTypeEnum.UNION, this.areaModel.union);
    } else if (e.value.length == 0 && e.previousValue.length > 0) {
      this.valueChanged(
        AreaFilterTypeEnum.SUB_DISTRICT,
        this.areaModel.sub_district,
      );
    }
  }

  private getWardList(projectId: string, unionId: string) {
    this.wardList = [];
    this.wardLoader = true;
    this.projectOfficeService
      .getProjectOfficeAreaListByProjects(
        projectId,
        AreaFilterTypeEnum.WARD,
        unionId,
      )
      .pipe(
        mergeMap((x) => x),
        filter((x: any) =>
          this.isFromDataCollection
            ? this.projectUserAreaIds?.ward_id.some((id) => id === x.ward_id)
            : true,
        ),
        toArray(),
      )
      .subscribe(
        (result) => {
          this.wardLoader = false;
          this.wardList = this.utilitiesService.getFiltered(
            result,
            'is_active',
            true,
          );
          this.wardList = this.wardList.sort(
            this.utilitiesService.dynamicSort('ward_name'),
          );
          if (this.isMultiProject) {
            // add custom_ward_name like ward_name(union_name)
            this.wardList.forEach((element) => {
              element.ward_name = `${element.ward_name} (${element.union_name})`;
            });
          }
          this.wardList = this.wardList.filter(
            (item, index, self) =>
              index === self.findIndex((i) => i.ward_id === item.ward_id),
          );
        },
        (err) => {
          this.wardLoader = false;
        },
      );
  }

  public wardOptionChange(e) {
    this.resetArrayUpTo(AreaFilterTypeEnum.WARD);
    if (e.value.length > 0) {
      e.value.forEach((element) => {
        if (element) {
          this.areaModel.ward.push({
            id: element.ward_id,
            name: element.ward_name,
            project_id: element.project_id,
          });

          let index = this.selectedWARD.findIndex((s) => s == element.ward_id);
          if (index <= -1) {
            this.selectedWARD.push(element.ward_id);
          }
        }
      });
      this.valueChanged(AreaFilterTypeEnum.WARD, this.areaModel.ward);
    } else if (e.value.length == 0 && e.previousValue.length > 0) {
      this.valueChanged(AreaFilterTypeEnum.WARD, this.areaModel.ward);
    }
  }

  public staffChanged(e, area: AreaFilterTypeEnum): void {
    this.resetArrayUpTo(area);
    let index = this.workingAreaTypes.indexOf(area);
    this.workingAreaTypesAndStaffs[index].staff_ids = [];
    this.workingAreaTypesAndStaffs[index].staff_names = [];
    this.workingAreaTypesAndStaffs[index].area_filter_ids = [];
    this.workingAreaTypesAndStaffs[index].area_filter_names = [];
    if (e.value.length == 0 && e.previousValue.length > 0) {
      index = this.workingAreaTypes.indexOf(area) - 1;
      this.emitAreaModel(index.toString());
    }
    if (e.value.length > 0) {
      const values = [];
      e.value.forEach((itm) => {
        this.workingAreaTypesAndStaffs[index].staff_ids.push(itm.user_id);
        this.workingAreaTypesAndStaffs[index].staff_names.push(itm.name);
        switch (itm.working_area_type) {
          case AreaFilterTypeEnum.HEAD_OFFICE:
            this.workingAreaTypesAndStaffs[index].area_filter_ids = [];
            this.workingAreaTypesAndStaffs[index].area_filter_names = [];
            break;
          case AreaFilterTypeEnum.UPAZILA:
            this.workingAreaTypesAndStaffs[index].area_filter_ids.push(
              itm.sub_district_id,
            );
            this.workingAreaTypesAndStaffs[index].area_filter_names.push(
              itm.sub_district_name,
            );
            break;
          default:
            this.workingAreaTypesAndStaffs[index].area_filter_ids.push(
              itm[itm.working_area_type?.toLowerCase() + '_id'],
            );
            this.workingAreaTypesAndStaffs[index].area_filter_names.push(
              itm[itm.working_area_type?.toLowerCase() + '_name'],
            );
            break;
        }
        values.push(itm.user_id);
      });
      const areaValue =
        index != this.workingAreaTypes?.length - 1
          ? this.workingAreaTypes[index + 1]
          : null;
      if (areaValue != null) {
        this.getStaffsByProject(areaValue, values).subscribe((result) => {
          this[areaValue.toLowerCase().replace(/\s/g, '') + 'StaffList'] =
            result;

          if (
            result?.length > 0 &&
            index !== this.workingAreaTypes?.length - 1
          ) {
            this.workingAreaTypesAndStaffs[index].area_filter_ids = [];
            result.forEach((element) => {
              switch (area) {
                case AreaFilterTypeEnum.HEAD_OFFICE:
                  break;
                case AreaFilterTypeEnum.UPAZILA:
                  this.workingAreaTypesAndStaffs[index].area_filter_ids.push(
                    element.sub_district_id,
                  );
                  break;
                default:
                  this.workingAreaTypesAndStaffs[index].area_filter_ids.push(
                    element[area?.toLowerCase() + '_id'],
                  );
                  break;
              }
            });
          }
          this.emitAreaModel(index.toString());
          return;
        });
      } else {
        this.emitAreaModel(index.toString());
      }
    }
  }

  private async emitAreaModel(key: string = null): Promise<void> {
    if (this.filterStaff) {
      const index = parseInt(key);
      this.workingAreaTypesAndStaffs[index].area_filter_ids = [
        ...new Set(this.workingAreaTypesAndStaffs[index].area_filter_ids),
      ];
      this.valueChange.emit({
        index: index,
        model: this.workingAreaTypesAndStaffs,
      });
    } else {
      this.areaModel.filter_type = key;
      this.areaModel.filter_value = this.areaModel[key.toLowerCase()].map(
        (obj) => obj.id,
      );
      if (!this.isFromDataCollection) {
        this.valueChange.emit(this.areaModel);
      } else {
        this.valueChange.emit({
          area_model: this.areaModel,
          user_areas: this.projectUserAreaIds,
        });
      }
    }
  }

  private resetArrayUpTo(key: string): void {
    switch (key) {
      case AreaFilterTypeEnum.HEAD_OFFICE:
        this.divisionStaffList = [];
        this.districtStaffList = [];
        this.sub_districtStaffList = [];
        this.upazilaStaffList = [];
        this.unionStaffList = [];
        this.wardStaffList = [];

        this.selectedDIVISIONStaff = [];
        this.selectedDISTRICTStaff = [];
        this.selectedSUB_DISTRICTStaff = [];
        this.selectedUNIONStaff = [];
        this.selectedWARDStaff = [];
        break;
      case AreaFilterTypeEnum.DIVISION:
        this.areaModel.division = [];
        this.districtList = [];
        this.subDistrictList = [];
        this.unionList = [];
        this.wardList = [];

        this.selectedDISTRICT = [];
        this.selectedSUB_DISTRICT = [];
        this.selectedUNION = [];
        this.selectedWARD = [];

        this.districtStaffList = [];
        this.sub_districtStaffList = [];
        this.upazilaStaffList = [];
        this.unionStaffList = [];
        this.wardStaffList = [];

        this.selectedDISTRICTStaff = [];
        this.selectedSUB_DISTRICTStaff = [];
        this.selectedUNIONStaff = [];
        this.selectedWARDStaff = [];
        break;
      case AreaFilterTypeEnum.DISTRICT:
        this.areaModel.district = [];
        this.subDistrictList = [];
        this.unionList = [];
        this.wardList = [];

        this.selectedSUB_DISTRICT = [];
        this.selectedUNION = [];
        this.selectedWARD = [];

        this.sub_districtStaffList = [];
        this.upazilaStaffList = [];
        this.unionStaffList = [];
        this.wardStaffList = [];

        this.selectedSUB_DISTRICTStaff = [];
        this.selectedUNIONStaff = [];
        this.selectedWARDStaff = [];
        break;
      case AreaFilterTypeEnum.SUB_DISTRICT:
        this.areaModel.sub_district = [];
        this.unionList = [];
        this.wardList = [];

        this.selectedUNION = [];
        this.selectedWARD = [];

        this.unionStaffList = [];
        this.wardStaffList = [];

        this.selectedUNIONStaff = [];
        this.selectedWARDStaff = [];
        break;
      case AreaFilterTypeEnum.UPAZILA:
        this.unionStaffList = [];
        this.wardStaffList = [];

        this.selectedUNIONStaff = [];
        this.selectedWARDStaff = [];
        break;
      case AreaFilterTypeEnum.UNION:
        this.areaModel.union = [];
        this.areaModel.ward = [];
        this.wardList = [];
        this.selectedWARD = [];
        this.wardStaffList = [];
        this.selectedWARDStaff = [];
        break;
      case AreaFilterTypeEnum.WARD:
        this.areaModel.ward = [];
        break;
      default:
        break;
    }
  }

  public isAreaTypeShow(currentAreaType: string): boolean {
    if (currentAreaType == AreaFilterTypeEnum.WARD) {
      if (this.areaTypeLevel == AreaFilterTypeEnum.WARD) {
        return true;
      } else return false;
    }
    if (currentAreaType == AreaFilterTypeEnum.UNION) {
      if (
        this.areaTypeLevel == AreaFilterTypeEnum.WARD ||
        this.areaTypeLevel == AreaFilterTypeEnum.UNION
      ) {
        return true;
      } else return false;
    }

    if (currentAreaType == AreaFilterTypeEnum.SUB_DISTRICT) {
      if (
        this.areaTypeLevel == AreaFilterTypeEnum.WARD ||
        this.areaTypeLevel == AreaFilterTypeEnum.UNION ||
        this.areaTypeLevel == AreaFilterTypeEnum.SUB_DISTRICT
      ) {
        return true;
      } else return false;
    }

    if (currentAreaType == AreaFilterTypeEnum.DISTRICT) {
      if (
        this.areaTypeLevel == AreaFilterTypeEnum.WARD ||
        this.areaTypeLevel == AreaFilterTypeEnum.UNION ||
        this.areaTypeLevel == AreaFilterTypeEnum.SUB_DISTRICT ||
        this.areaTypeLevel == AreaFilterTypeEnum.DISTRICT
      ) {
        return true;
      } else return false;
    }

    if (currentAreaType == AreaFilterTypeEnum.DIVISION) {
      if (
        this.areaTypeLevel == AreaFilterTypeEnum.WARD ||
        this.areaTypeLevel == AreaFilterTypeEnum.UNION ||
        this.areaTypeLevel == AreaFilterTypeEnum.SUB_DISTRICT ||
        this.areaTypeLevel == AreaFilterTypeEnum.DISTRICT ||
        this.areaTypeLevel == AreaFilterTypeEnum.DIVISION
      ) {
        return true;
      } else return false;
    }
    return false;
  }

  getAreaTypeByProject(projectId) {
    this.workingAreaTypes = [];
    this.workingAreaTypesAndStaffs = [];
    // Get working area type
    this.roleHierarchyService.getWorkingAreaTypes(projectId, false).subscribe(
      (result) => {
        if (result.length > 0) {
          this.workingAreaTypes = result;
          result.forEach((obj) => {
            this.workingAreaTypesAndStaffs.push({
              area_filter_type: obj,
              staff_ids: [],
              staff_names: [],
              area_filter_ids: [],
              area_filter_names: [],
            });
          });
          if (this.filterStaff) {
            this.headofficeStaffList = [];
            this.getStaffsByProject(
              this.areaFilterTypeEnum.HEAD_OFFICE,
              [],
            ).subscribe((results) => {
              this.headofficeStaffList = results;
            });
          }
        } else {
          this.utilitiesService.showSwalWithToast(
            'No Working area found',
            'No working area found.',
            'info',
          );
        }
      },
      (err) => {},
    );
  }

  public getStaffsByProject(
    areaFilterType: AreaFilterTypeEnum,
    reporterUserFilterValues: string[],
  ): Observable<any> {
    return this.staffMappingService.getReportingSubordinateUsers(
      this.projectId,
      areaFilterType,
      reporterUserFilterValues,
    );
  }

  findWorkingAreaTypes(areaType: string): boolean {
    if (this.isWorkingTypeFilter) {
      if (this.workingAreaTypes?.length > 0) {
        const index = this.workingAreaTypes.indexOf(areaType);
        if (index !== -1) {
          return true;
        } else {
          return false;
        }
      } 
      return false;
    } else {
      return true;
    }
  }

  async getProjectUserAreaIds() {
    const userId = this.localStorageService.getSessionUser()?.id ?? null;
    if (userId) {
      this.projectUserAreaIds = await lastValueFrom(
        this.staffMappingService.getProjectUserAreaIds(userId, this.projectId),
      );
      this.getDivisionList(this.projectId);
      ValidationEngine.resetGroup(this.areaValidationGroupName);
    }
  }
}
